module.exports = __webpack_public_path__ + "static/media/iconBO.6b7fae59.svg";